const randomInt = (min: number, max: number): number => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const isTrueByChance = (percentChange: number): boolean => {
    return Math.random() < percentChange / 100;
}

const getSliceValues = (percentages: any, currentStep: number, lastSliceIndex: number, lastSampleIndex: number, sampleCount: number, sliceDuration: number, time: number) => {
    let sliceIndex: number = currentStep
    let retrig = 0
    let duration = sliceDuration

    // a step keeps playing the sample of the step before it; SWITCH forces a
    // jump to one of the *other* samples so a hit always audibly switches
    let sampleIndex: number = lastSampleIndex
    if (sampleCount > 1 && isTrueByChance(percentages.switchSample)) {
        sampleIndex = (lastSampleIndex + randomInt(1, sampleCount - 1)) % sampleCount
    }

    switch (true) {
        case isTrueByChance(percentages.retrig) && sliceIndex !== 0:
            retrig = [2, 4][randomInt(0, 1)]
            break
    }

    // RANDOM rolls first and is the only way to leave the grid; NEXT then
    // decides per step whether to keep following the sequence a jump started.
    // On an unjumped sequence lastSlice + 1 is the grid slice anyway, so NEXT
    // without RANDOM changes nothing.
    switch (true) {
        case isTrueByChance(percentages.randomSlice) && currentStep !== 0:
            sliceIndex = randomInt(0, 15)
            break
        case isTrueByChance(percentages.nextSlice) && lastSliceIndex < 15 && currentStep !== 0:
            sliceIndex = lastSliceIndex + 1
            break
    }

    let player = 'normal'

    switch (true) {
        case isTrueByChance(percentages.hiPitch):
            player = 'hi'
            break
        case isTrueByChance(percentages.loPitch):
            player = 'lo'
            break
        case isTrueByChance(percentages.reverse) && sliceIndex !== 0 && retrig === 0:
            player = 'reverse'
            time -= duration
            break
    }

    return [player, sliceIndex, sampleIndex, retrig, duration, time]
}

export {getSliceValues, isTrueByChance, randomInt}
